import Image from "@tiptap/extension-image";
import { ReactNodeViewRenderer } from "@tiptap/react";
import ResizableImageView from "./ResizableImageView";

export const ResizableImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
        parseHTML: (el) => el.style.width || el.getAttribute("width") || null,
        renderHTML: () => ({}),
      },
      align: {
        default: "center",
        parseHTML: (el) => el.getAttribute("data-align") || "center",
        renderHTML: () => ({}),
      },
    };
  },
  renderHTML({ HTMLAttributes, node }) {
    const { width, align } = node.attrs;
    let style = "";
    if (align === "left") style = "float:left;margin:0.25rem 1.25rem 0.5rem 0;";
    else if (align === "right") style = "float:right;margin:0.5rem 0 0.5rem 1.25rem;";
    else style = "display:block;margin:1rem auto;clear:both;";
    if (width) style += `width:${width};`;
    style += "max-width:100%;height:auto;";
    const { width: _w, align: _a, ...rest } = HTMLAttributes;
    return ["img", { ...rest, "data-align": align, style }];
  },
  addNodeView() {
    return ReactNodeViewRenderer(ResizableImageView);
  },
});
